export type SuppliersListUrlState = {
  name: string;
  country: string | null;
  city: string | null;
};

export const buildSuppliersListSearch = (
  params: SuppliersListUrlState | null | undefined,
) => {
  if (!params) return '';
  const search = new URLSearchParams();
  if (params.name != null && params.name !== '') {
    search.set('name', params.name);
  }
  if (params.country != null && params.country !== '') {
    search.set('country', params.country);
  }
  if (params.city != null && params.city !== '') {
    search.set('city', params.city);
  }
  const str = search.toString();
  return str ? `?${str}` : '';
};
